import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { createProvider } from './vue-apollo'
import './scss/main.scss'
import VueMeta from 'vue-meta'
import VueMarkdown from 'vue-markdown'
import VueMoment from 'vue-moment'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'UA-64472626-1' }
}, router)

Vue.use(VueMoment)
Vue.use(VueMeta)
Vue.component('vue-markdown', VueMarkdown)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
